<template>
  <div style="width: 100%;">
    <div class="top-step">
      <el-steps :active="activeSteps" align-center finish-status="success">
        <el-step title="事项选择"></el-step>
        <el-step title="点位选择"></el-step>
        <el-step title="创建任务"></el-step>
      </el-steps>
    </div>
    <div class="bottom-info">
      <div class="content">
        <events
          @updateEventsData="updateEventsData"
          @regionChange="regionChange"
          ref="ref0"
          :eventsInfo="eventsInfo"
          v-if="isShow && lookId && activeSteps == 0"
          :typeTask="1"
        ></events>
        <events
          @updateEventsData="updateEventsData"
          @regionChange="regionChange"
          ref="ref0"
          :eventsInfo="eventsInfo"
          v-if="!isShow && !lookId && activeSteps == 0"
          :typeTask="1"
        ></events>
        <point
          @updatePointsData="updatePointsData"
          :pointInfo="pointInfo"
          ref="ref1"
          v-if="activeSteps == 1"
        ></point>
        <template v-if="activeSteps == 2">
          <el-form
            ref="form"
            style="margin-bottom: 0;"
            :model="form"
            label-position="left"
          >
            <!-- <el-form-item
              label="任务创建时间"
              style="display: flex;align-items: center;"
            >
              <el-radio-group v-model="form.nowCreateFlag">
                <el-radio label="立即创建"></el-radio>
                <el-radio label="自定义时间"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.nowCreateFlag == '自定义时间'" label="">
              <el-time-picker
                v-model="form.timeStr"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                placeholder="选择时间"
              >
              </el-time-picker>
            </el-form-item> -->
            <el-form-item label="网格每日完成次数">
              <el-input-number v-model="form.dayTimes"></el-input-number
              >
              <!-- <span>（在该时限未完成时，提醒超时）</span> -->
            </el-form-item>
            <el-form-item label="包片科室每周完成次数">
              <el-input-number v-model="form.ksWeekTimes"></el-input-number
              >
              <!-- <span>（距离任务截止剩余该时限时，提醒即将超时）</span> -->
            </el-form-item>
          </el-form>
        </template>
      </div>
      <div class="footer">
        <el-button class="reset" @click="backHome">取消</el-button>
        <el-button v-if="activeSteps > 0" @click="prevSteps">上一步</el-button>
        <el-button v-if="activeSteps < 2" @click="nextSteps" class="search"
          >下一步</el-button
        >
        <el-button v-if="activeSteps == 2 && !lookId" @click="createFun" class="search"
          >创建任务</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import events from "./events";
import point from "./point";
import person from "./person";
import moment from "moment";
import { infiniteEventFullDetail, createTempTask, createInfiniteTask } from "@/api/task.js";
export default {
  components: { events, point, person },
  props: {
    typeTask: {
      type: Number
    },
    lookId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      activeSteps: 0,
      form: {
        dayTimes: 1,
        ksWeekTimes: 1,
      },
      eventsInfo: {
        pointLevelIdList: [],
        selectedIdOptions: [],
        indexList: [],
        eventInfo: {
          sxmc: "",
          dayTimes: 1,
          ksWeekTimes: 1,
          id: ''
        }
      },
      pointInfo: {
        selectedOptions: [],
        selectedIdOptions: []
      },
      personList: [],
      isShow: false
    };
  },
  mounted() {
    this.isShow = false;
    if (this.lookId) {
      this.lookDialogFun(this.lookId)
    }
  },

  methods: {
    async lookDialogFun(id) {
      let res = await infiniteEventFullDetail({
        eventId: id
      })
      if (res.data.code == 200) {
        this.eventsInfo = res.data.data;
        this.pointInfo.selectedOptions = res.data.data && res.data.data.pointLevelIdList;
        this.pointInfo.selectedIdOptions = res.data.data && res.data.data.pointLevelIdList;
        this.form.dayTimes = res.data.data && res.data.data.eventInfo.dayTimes;
        this.form.ksWeekTimes = res.data.data && res.data.data.eventInfo.ksWeekTimes;
        this.isShow = true;
      }
    },
    regionChange() {
      this.eventsInfo = {
        pointLevelIdList: [],
        selectedIdOptions: [],
        indexList: [],
        eventInfo: {
          sxmc: "",
          dayTimes: 1,
          ksWeekTimes: 1,
          id: ''
        }
      };
      this.pointInfo = {
        selectedOptions: [],
        selectedIdOptions: []
      };
      this.personList = [];
    },
    updatePerson(data) {
      this.activeSteps++;
      this.personList = data;
    },
    backHome() {
      this.$emit("back");
    },
    updateEventsData(data) {
      this.eventsInfo = data;
      this.activeSteps++;
    },
    updatePointsData(data) {
      this.pointInfo = data;
      this.eventsInfo.pointLevelIdList = data.selectedIdOptions;
      this.activeSteps++;
    },
    nextSteps() {
      if (this.activeSteps >= 3) return;
      this.$refs[`ref${this.activeSteps}`].nextStepsFun();
    },
    prevSteps() {
      if (this.activeSteps < 1) return;
      this.activeSteps--;
    },
    createFun() {
        let params = {
          pointLevelIdList: this.eventsInfo.pointLevelIdList,
          indexList: this.eventsInfo.indexList,
          eventInfo: {
            ...this.eventsInfo.eventInfo,
            dayTimes: this.form.dayTimes,
            ksWeekTimes: this.form.ksWeekTimes
          }
        };
        this.GhTaskTempTaskDiyParamFun(params);

    },
    async createTempTaskFun(params) {
      // let xx = true;
      // this.$refs["form"].validate(valid => {
      //   if (valid) {
      //     xx = true;
      //   } else {
      //     xx = false;
      //   }
      // });
      // if (xx == false) {
      //   this.$message({
      //     message: "请输入或选择必填项",
      //     type: "warning"
      //   });
      //   return false;
      // }
      const res = await createTempTask(params);

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "创建成功"
        });
        this.backHome();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async GhTaskTempTaskDiyParamFun(params) {
      const res = await createInfiniteTask(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "创建成功"
        });
        this.backHome();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.top-step {
  width: 817px;
  padding: 40px 0;
  margin: 0 auto;
}
.bottom-info {
  height: calc(100% - 150px);
  .content {
    height: calc(100% - 54px);
    width: 900px;
    margin: 0 auto;
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
/deep/.el-step__head.is-success,
/deep/.el-step__head.is-process {
  .is-text {
    width: 36px;
    height: 36px;
    background: #0495ff;
    border: 1px solid #0495ff;
    .el-icon-check:before {
      color: #fff;
    }
    .el-step__icon-inner {
      color: #fff;
    }
  }
}
/deep/.el-step__title.is-success,
/deep/.el-step__title.is-process {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #494c4f;
}
/deep/.el-step__head.is-wait {
  .is-text {
    width: 36px;
    height: 36px;
    background: #f1f4f6;
    border: 1px solid #f1f4f6;
    .el-step__icon-inner {
      color: #9bb6c9;
    }
  }
}
/deep/.el-step__title.is-wait {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #86909c;
}
/deep/.el-step__line {
  background: none;
}
/deep/.el-step.is-horizontal .el-step__line {
  top: 18px;
}
/deep/.el-step__line-inner {
  border-style: dashed !important;
  border-color: #dde6ec !important;
  width: 100% !important;
  border-width: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/components/createThree.vue